// extracted by mini-css-extract-plugin
module.exports = {"bg":"home_bg__39lU5","container":"home_container__2YNhO"};